import { createRoutine } from "redux-saga-routines";

export const QuestionsActionType = {
  showQuestions: 'QUESTIONS/SHOW_QUESTIONS',
};

export const showQuestionsRoutine = createRoutine(QuestionsActionType.showQuestions);